import HomeScreenCard from "../HomeScreenCard";
import CardStatusBar from "../CardStatusBar";
import { CardOfTheDayStatus } from "../../types/CardOfTheDayStatus";
import HomeCardTitle from "../HomeCardTitle";
import CardFan from "../CardFan";
import starsBackground from "@/assets/img/d_stars_background_1.png";
import cardPattern from "@/assets/img/img_card_pattern.webp";

interface CardOfTheDayCardProps {
  cardOfTheDayStatus: CardOfTheDayStatus | null;
  navigateToCardOfTheDay: () => void;
  gridColumn: string;
  gridRow: string;
}

export const CardOfTheDayCard = ({
  cardOfTheDayStatus,
  navigateToCardOfTheDay,
  gridColumn,
  gridRow,
}: CardOfTheDayCardProps) => (
  <HomeScreenCard
    statusBar={
      <CardStatusBar
        text={cardOfTheDayStatus?.timeToNextCard ?? ""}
        isAvailable={cardOfTheDayStatus?.isAvailable ?? false}
      />
    }
    gridColumn={gridColumn}
    gridRow={gridRow}
    bgStyle={{
      background: `url(${starsBackground}) center/cover`,
    }}
    onClick={() => navigateToCardOfTheDay()}
    style={{ cursor: "pointer" }}
  >
    <div
      className={`p-2 sm:p-3 md:p-4 flex flex-col h-[calc(100%-20px)]`}
      style={{ zIndex: 20, cursor: "pointer" }}
    >
      <HomeCardTitle
        title="Карта дня"
        isNeedShort={true}
        subtitle={cardOfTheDayStatus?.card?.name ?? ""}
        description={cardOfTheDayStatus?.card?.description ?? ""}
      />
      {cardOfTheDayStatus?.card?.image ? (
        <div
          className="p-2 sm:p-3 md:p-4"
          style={{
            maxWidth: "100%",
            width: "100%",
            overflow: "hidden",
            boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={
              cardOfTheDayStatus?.card?.image ?? cardPattern
            }
            alt="card-back-center"
            className={` rounded-lg shadow  ${cardOfTheDayStatus?.card?.image
              ? "bg-white"
              : "bg-transparent"
              }`}
            style={{
              aspectRatio: "11/19",
              height: "100%",
              width: "auto",
              padding: "2px",
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>
      ) : (
          <CardFan
            firstCard={
              <img
                src={
                  cardOfTheDayStatus?.card?.image ?? cardPattern
                }
                alt="card-back-center"
                className={` rounded-lg shadow  ${cardOfTheDayStatus?.card?.image
                  ? "bg-white"
                  : "bg-transparent"
                  }`}
                  style={{
                    height: "85%" ,
                    width: "75px",
                    padding: "2px",
                    objectFit: "cover",
                    display: "block",
                  }}
              />
            }
            centerCard={
              <img
                src={
                  cardOfTheDayStatus?.card?.image ?? cardPattern
                }
                alt="card-back-center"
                className={` rounded-lg shadow  ${cardOfTheDayStatus?.card?.image
                  ? "bg-white"
                  : "bg-transparent"
                  }`}
                style={{
                  height: "85%" ,
                  width: "100px",
                  padding: "2px",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            }
            lastCard={
              <img
                src={
                  cardOfTheDayStatus?.card?.image ?? cardPattern
                }
                alt="card-back-center"
                className={` rounded-lg shadow  ${cardOfTheDayStatus?.card?.image
                  ? "bg-white"
                  : "bg-transparent"
                  }`}
                  style={{
                    height: "85%" ,
                    width: "75px",
                    padding: "2px",
                    objectFit: "cover",
                    display: "block",
                  }}
              />
            }
          />
      )}
    </div>
  </HomeScreenCard>
);
